import React from "react";
import { connect } from "react-redux";
import * as revaThunks from "../../../../redux/thunks/revaThunks";
import PriceListTable from "./PriceListTable";

const PriceListTableContainer = ({
    show,
    tournamentId,
    priceLists,
    loading,
    loadPriceList,
    savePriceItem,
    deletePriceItem,
}) => {
    if (!show) return null;

    return (
        <PriceListTable
            tournamentId={tournamentId}
            priceList={priceLists?.[tournamentId] || []}
            loading={loading?.reva || {}}
            loadingFetch={loading?.reva?.loadPriceList}
            loadPriceList={loadPriceList}
            savePriceItem={savePriceItem}
            deletePriceItem={deletePriceItem}
        />
    );
};

const mapState = (state) => ({
    priceLists: state.reva.priceLists,
    loading: state.loading,
});

const mapDispatch = (dispatch) => ({
    loadPriceList: (tournamentId) => dispatch(revaThunks.loadPriceList(tournamentId)),
    savePriceItem: (priceData) => dispatch(revaThunks.savePriceItem(priceData)),
    deletePriceItem: (id, tournamentId) => dispatch(revaThunks.deletePriceItem(id, tournamentId)),
});

export default connect(mapState, mapDispatch)(PriceListTableContainer);
